import React, { HTMLAttributes, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import store from "store";
import { post_symbolStar, delete_symbolStarId } from "api/v4/account";

import { Tooltip, TooltipProps } from "antd";
import XtSvg from "components/xt/svg";
import AppDivToLogin from "components/app/div/toLogin";

import styles from "./index.module.scss";

// import { SymbolStarProps } from "store/user";

interface Props extends HTMLAttributes<HTMLButtonElement> {
  symbol: string;
  placement?: TooltipProps["placement"];
  isStarEmpty?: boolean;
  /** 图标颜色，如 "#fff"、"white"，不传则使用主题默认色 */
  iconColor?: string;
}

const Main: React.FC<Props> = ({ symbol, className, placement = "topLeft", isStarEmpty, iconColor }) => {
  const t = useTranslation();
  const { isLogin, symbolStar } = store.user;

  const atvDoc: WithUndefined<string> = useMemo(() => {
    if (!isLogin) return;
    return symbolStar.find((obj) => obj === symbol);
  }, [isLogin, symbol, symbolStar]);
  const tip = useMemo(() => {
    return !atvDoc ? t("trade.favorites") : t("trade.cancel");
  }, [atvDoc]);

  const [loading, setLoading] = useState(false);
  const handleClick = (e) => {
    e && e.stopPropagation();
    if (!isLogin || loading) return;
    setLoading(true);

    if (atvDoc) {
      delete_symbolStarId(atvDoc)
        .then(() => {
          store.user.getSymbolStar();
        })
        .catch(() => {
          //empty
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      post_symbolStar({
        params: { symbol },
      })
        .then(() => {
          store.user.getSymbolStar();
        })
        .catch(() => {
          //empty
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // const showEmptyStar = useMemo(() => {
  //   return !(atvDoc || !isStarEmpty);
  // }, [atvDoc, isStarEmpty]);

  // 未收藏时用传入的 iconColor（如白色），收藏态与 market 一致用主题绿色 .atv
  const btnStyle = iconColor && !atvDoc ? { color: iconColor } : undefined;

  return (
    <>
      {isLogin ? (
        <button
          className={cx("btnTxt", styles.main, className, { [styles.atv]: !!atvDoc })}
          style={btnStyle}
          onClick={handleClick}
        >
          <XtSvg icon={atvDoc ? "star-new-filled" : "star-new-empty"} />
        </button>
      ) : (
        <Tooltip
          trigger={isLogin ? "hover" : "click"}
          placement={placement}
          getPopupContainer={(triggerNode: HTMLElement) => triggerNode}
          title={isLogin ? tip : <AppDivToLogin />}
          overlayStyle={{ whiteSpace: "nowrap" }}
        >
          <button
            className={cx("btnTxt", styles.main, className, { [styles.atv]: !!atvDoc })}
            style={btnStyle}
            onClick={handleClick}
          >
            <XtSvg icon={atvDoc ? "star-new-filled" : "star-new-empty"} />
          </button>
        </Tooltip>
      )}
    </>
  );
};

export default observer(Main);
